import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.css']
})
export class QrCodeComponent implements OnInit {
  userAgent:string="";
  constructor(private _p:Platform) { 
  }

  ngOnInit(): void {
    this.getPlatform();
  }
  getPlatform(){
    if(this._p.ANDROID){
      window.open("https://play.google.com/store/apps/details?id=com.zimblecode.wetap","_self");
    }
    else if(this._p.IOS)
    {
      window.open("https://apps.apple.com/us/app/get-wetap/id1660750697","_self");
    }else{
      console.log("Window platform");
      window.open("https://getwetap.com/","_self");
    }
  }
    







  // getUserAgent(){
  //   if(navigator.platform.indexOf("Win")!=-1) this.userAgent="Windows";
  //   if(navigator.platform.indexOf("Mac")!=-1) this.userAgent="MacOs";
  //   if(navigator.platform.indexOf("iPhone")!=-1) this.userAgent="iOS";
  //   if(navigator.platform.indexOf("Android")!=-1) this.userAgent="Android";
  //   if(this.userAgent === "iPhone"){
  //    window.open("https://apps.apple.com/us/app/get-wetap/id1660750697","_self");
  //    }
  //    if(this.userAgent === "Windows" || "MacOs"){
  //     window.open("https://getwetap.com/","_self");
  //    }
  //    if(this.userAgent === "Android" || this.userAgent === ""){
  //     window.open("https://play.google.com/store/apps/details?id=com.zimblecode.wetap","_self");
  //    }
  // }
}
